import { __decorate } from "tslib";
import { Directive, Output, EventEmitter, HostBinding, HostListener, ElementRef } from "@angular/core";
let DragDropDirective = class DragDropDirective {
    el;
    onFileDropped = new EventEmitter();
    background = "#f5fcff";
    opacity = "1";
    constructor(el) {
        this.el = el;
    }
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.el.nativeElement.querySelector(".drag-drop-label").style.color = "#243391";
        this.background = "#9ecbec";
        this.opacity = "0.8";
    }
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.el.nativeElement.querySelector(".drag-drop-label").style.color = "#243391";
        this.background = "#f5fcff";
        this.opacity = "1";
    }
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = "#f5fcff";
        this.opacity = "1";
        this.el.nativeElement.querySelector(".drag-drop-label").style.color = "gray";
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.onFileDropped.emit(files);
        }
    }
    static ctorParameters = () => [
        { type: ElementRef }
    ];
    static propDecorators = {
        onFileDropped: [{ type: Output }],
        background: [{ type: HostBinding, args: ["style.background-color",] }],
        opacity: [{ type: HostBinding, args: ["style.opacity",] }],
        onDragOver: [{ type: HostListener, args: ["dragover", ["$event"],] }],
        onDragLeave: [{ type: HostListener, args: ["dragleave", ["$event"],] }],
        ondrop: [{ type: HostListener, args: ["drop", ["$event"],] }]
    };
};
DragDropDirective = __decorate([
    Directive({
        selector: "[appDragDrop]"
    })
], DragDropDirective);
export { DragDropDirective };
